export enum EntityType {
  Character,
  Car,
  Decoration,
  System,
  UIOverlay,
  Prop,
}
